import React, {useEffect, useState} from 'react';
import {Head, Loading} from "../../components";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import { Tooltip} from "@mui/material";
import moment from 'moment-jalaali'
import Api from "../../utils/api";
import Button from "@mui/material/Button";
import DepotOrderList from "../../components/Depot/OrderList";
import Accumulative from "../../components/Depot/Accumulative";
import {toast} from "react-toastify";
import PrintFactor from "../../components/Depot/Print/factor";
import PrintLabel from "../../components/Depot/Print/label";

const Depot = ( props ) => {

    const [loading, setLoading] = useState(false);
    const [entities, setEntities] = useState([]);
    // const [accumulative, setAccumulative] = useState([]);
    // const [exporter, setExporter] = useState(false);


    useEffect(() => {
        handleRequest();
    }, []);

    const handleRequest = () => {

        setLoading(true);

        new Api().get('/depot').then((response) => {
            if (typeof response !== "undefined") {
                setEntities(response);
            }

            setLoading(false);
        })
    };


    const handleExit = (id) => {
        new Api().put('/depot/' + id + '/exit').then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success('موفقیست آمیز');
                    handleRequest();
                }
            }
        })
    }



    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت انبار', 'description': 'انبار را مدیریت کنید' }} />
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>تعداد سفارشات</th>
                            <th>تجمیعی</th>
                            <th>فاکتور</th>
                            <th>بارکد</th>
                            <th>برچسب انبار</th>
                            <th>به روزرسانی</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {entities.length > 0 && entities.map((entity, index) => {
                            return(
                                <tr key={index}>
                                    <td>{entity.id}</td>
                                    <td>{'گزارش از فاکتورهای' + ' ' + entity.from_order + ' تا ' + entity.to_order}</td>
                                    <td>{entity.count}</td>
                                    <td>{entity.accumulative}</td>
                                    <td>{entity.factor}</td>
                                    <td>{entity.barcode}</td>
                                    <td>{entity.label}</td>
                                    <td style={{ direction: 'ltr'}}>{moment(entity.updated_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td>
                                        <DepotOrderList onComplete={() => handleRequest()} id={entity.id}/>&nbsp;
                                        <Accumulative onComplete={() => handleRequest()} depot={entity} id={entity.id}/>&nbsp;
                                        <Button onClick={() => toast.info('نیازمند وبسرویس پست')} style={{ marginBottom: 5}} size={"small"} variant={"outlined"}>تولید بارکد</Button>&nbsp;
                                        <PrintFactor onComplete={() => handleRequest()}  id={entity.id} />&nbsp;
                                        <PrintLabel onComplete={() => handleRequest()}  id={entity.id} />&nbsp;
                                        <Button onClick={() => handleExit(entity.id)} style={{ marginBottom: 5}} size={"small"} variant={"outlined"}>خروج از انبار</Button>&nbsp;
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </>
            {loading && <Loading/>}
        </Container>

    );
}


export default Depot;
